module.exports = __webpack_public_path__ + "img/new_version_f-22_gears_down.asm.6cb36856.jpg";